// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"49":"microsoft_teams","200":"pdffonts","378":"docx","518":"pptxgenjs","578":"jszip","643":"pdfmake"}[chunkId] + "." + {"49":"97dcad48","200":"48c761a4","378":"ad14e77a","518":"35b6f1fa","578":"7ae797df","643":"fcc13ebe"}[chunkId] + ".js";
};